/**
 * The 2026 event is over and the site no longer accepts registrations.
 *
 * Flip REGISTRATIONS_CLOSED to false to reopen. There is a second copy of this
 * flag for the edge functions in supabase/functions/_shared/registrationsClosed.ts,
 * because Deno functions cannot import from src/. Flip both.
 *
 * House style: no em-dashes or en-dashes in copy.
 */
export const REGISTRATIONS_CLOSED = true;

export const CLOSED_HEADLINE = 'Thanks for 2026, see you in 2027!';

export const CLOSED_NOTE = 'Registration for 2026 is closed.';

/**
 * Internal paths that are closed while REGISTRATIONS_CLOSED is true.
 * Shared by Navigation and Footer so their filters cannot drift apart.
 * "/vendor-registration" matches itself and anything under it, e.g.
 * "/vendor-registration/some-slug".
 */
export const CLOSED_PATHS = ['/event-registration', '/day-pass', '/vendor-registration'];

/**
 * True when the given internal path is one of the closed registration
 * routes. Match on path, not label, since labels are admin-editable free
 * text and can be renamed without notice.
 */
export function isClosedPath(path: string): boolean {
  return CLOSED_PATHS.some(closed => path === closed || path.startsWith(`${closed}/`));
}
